import React, { useState } from 'react';

export default function ResetPassword({ onNavigate }) {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Failed to reset password.'); }
      else { setSuccess(true); }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center max-w-md w-full">
          <div className="text-4xl mb-4">⚠️</div>
          <h2 className="text-xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Invalid Link</h2>
          <p className="text-gray-500 text-sm mb-6">This reset link is missing a token. Please request a new one.</p>
          <button onClick={() => onNavigate('forgot-password')} className="text-sm font-medium hover:underline" style={{ color: '#1B3A5C' }}>
            ← Request New Reset Link
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold" style={{ color: '#1B3A5C' }}>Ministry AI Toolkit</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          {success ? (
            <div className="text-center">
              <div className="text-4xl mb-4">✅</div>
              <h2 className="text-xl font-bold mb-2" style={{ color: '#1B3A5C' }}>Password Reset!</h2>
              <p className="text-gray-500 text-sm mb-6">Your password has been updated successfully.</p>
              <button
                onClick={() => onNavigate('login')}
                className="w-full py-2.5 rounded-lg text-white font-semibold transition-opacity hover:opacity-90"
                style={{ backgroundColor: '#C8921A' }}
              >
                Sign In
              </button>
            </div>
          ) : (
            <>
              <h2 className="text-xl font-bold mb-1" style={{ color: '#1B3A5C' }}>Set New Password</h2>
              <p className="text-gray-500 text-sm mb-6">Choose a new password for your account.</p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="At least 8 characters"
                    required
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                  <input
                    type="password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    placeholder="Repeat new password"
                    required
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
                  />
                </div>

                {error && <p className="text-sm text-red-600">{error}</p>}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2.5 rounded-lg text-white font-semibold transition-opacity hover:opacity-90 disabled:opacity-60"
                  style={{ backgroundColor: '#C8921A' }}
                >
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>

              <p className="text-center mt-5 text-sm text-gray-500">
                <button onClick={() => onNavigate('forgot-password')} className="font-medium hover:underline" style={{ color: '#1B3A5C' }}>
                  ← Request a new link
                </button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
